export default {
  getSubscriptionPlans: (state) => {
    return state.subscriptionPlans
  },
}
